module.exports = __webpack_public_path__ + "img/glassquality_1.cb658655.png";